/*
 * File: /src/stores/shop-customobjectsgroups-list.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 23rd August 2018 11:42:46 am
 * Last Modified: Monday, 27th August 2018 11:34:31 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
const initialState = () => ({
    scope: 'customobjectsgroups',
    metafields: [],
    usedKeys: []
})

const state = initialState()

const actions = {
    async GET_CUSTOM_OBJECTS_GROUPS({ state, commit, dispatch }) {
        let params = {
            endpoint: `customobjectsgroups`
        }

        try {
            const { metafields } = await dispatch('shopifyApi/REQUEST', params, { root: true })

            if (metafields) {
                commit('SET_METAFIELDS', { metafields })
                commit('SET_USED_KEYS', { metafields })
            }
        } catch (error) {
            console.error(`GET_CUSTOM_OBJECTS_GROUPS`, error)
            throw error
        }
    },

    async SAVE_CUSTOM_OBJECT_GROUP({ state, commit, dispatch }, { customObjectGroup }) {
        customObjectGroup.value = {
            label: customObjectGroup.label
        }

        let groupsNumber = state.metafields.length
        let nextNumber = groupsNumber + 1
        let finalKey

        while (!finalKey) {
            let testKey = `g_${nextNumber}`
            if (!state.usedKeys.includes(testKey)) {
                finalKey = testKey
            } else {
                nextNumber++
            }
        }

        customObjectGroup.key = finalKey

        let params = {
            endpoint: `customobjectsgroups`,
            method: 'POST',
            data: { customObjectGroup }
        }

        try {
            const { metafields } = await dispatch('shopifyApi/REQUEST', params, { root: true })

            if (metafields) {
                commit('SET_METAFIELDS', { metafields })
                commit('SET_USED_KEYS', { metafields })
            }
        } catch (error) {
            console.error(`SAVE_CUSTOM_OBJECT_GROUP`, error)
            throw error
        }
    },

    async REMOVE_CUSTOM_OBJECT_GROUP({ state, commit, dispatch }, { id }) {
        let params = {
            endpoint: `customobjectsgroups/${id}`,
            method: 'DELETE',
            data: { id }
        }

        try {
            const { metafields } = await dispatch('shopifyApi/REQUEST', params, { root: true })

            if (metafields) {
                commit('SET_METAFIELDS', { metafields })
                commit('SET_USED_KEYS', { metafields })
            }
        } catch (error) {
            console.error(`REMOVE_CUSTOM_OBJECT_GROUP`, error)
            throw error
        }
    }
}

const mutations = {
    SET_METAFIELDS(state, { metafields }) {
        state.metafields = metafields
    },

    SET_USED_KEYS(state, { metafields }) {
        state.usedKeys = metafields.map(item => {
            return item.key
        })
    }
}

const getters = {
    customObjectsGroupsMapped: state => {
        if (!state.metafields) {
            return null
        }

        return state.metafields.map(item => {
            return {
                id: item.id,
                name: item.value.label,
                schema: item.value.schema,
                to: { name: 'customobjectsgroups.manage', query: { id: item.id } },
                icon: 'text-block',
                editUrl: { name: 'customobjects.manage', query: { id: item.id } },
                editUrlPlacement: 'outer'
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/stores/shop-customobjectsgroups-list.js